import { Input } from '../ui/input';
import { SearchRecommend } from './search-recommend';
import SearchResult from './search-result';
import { InteractSearchIcon } from '@/client/assets';
import { cn } from '@/client/utils';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const SearchPanel = ({ className }: { className?: string }) => {
  const { t } = useTranslation();
  const [input, setInput] = useState('');
  return (
    <div className={cn('space-y-6 size-full flex flex-col', className)}>
      <div className="flex items-center bg-foreground/4 border border-foreground/10 rounded-full px-3.5 pos-sticky top-0">
        <InteractSearchIcon className="size-4 flex-shrink-0 fill-current" />
        <Input
          type="text"
          autoFocus
          value={input}
          onChange={e => setInput(e.target.value)}
          placeholder={t('search-markets-contract-address')}
          className="!ring-none !shadow-none !border-none text-base h-auto leading-5 py-3.5 font-medium duration-200 focus:placeholder:text-sm placeholder:text-base placeholder:text-foreground/40 w-full"
        />
        {input?.trim().length > 0 && (
          <span
            className="text-foreground/70 text-base leading-5 hover:text-foreground cursor-pointer whitespace-nowrap"
            onClick={() => setInput('')}
          >
            {t('clear')}
          </span>
        )}
      </div>
      <div className="flex-1 overflow-auto">
        {input?.trim().length === 0 && <SearchRecommend setInput={setInput} />}
        {input?.trim().length > 0 && <SearchResult keyword={input} />}
      </div>
    </div>
  );
};

export default SearchPanel;
